import {
  STASH,
  BUTTON_SUBMISSION,
  MY_ACCOUNT_SETTINGS,
  OVERLAY,
  ERROR
} from '../constants';

// analytics.ts (customer-common-security) - Firing Mechanism 2 shared event helpers
export const securityEvents = () => {
  // postStashEvent(identifier) - e.g. sign out everywhere click (DeviceManagement/index.tsx)
  window.LIFE_CYCLE_EVENT_BUS.on('security.stash-event', ({ output }) => {
    const identifier = output?.identifier || '';

    const DDOEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      eventMode: STASH,
      stash: {
        myAccount: {
          settings: identifier
        }
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  // postSubmissionEvent(eventName) - biometric enrollment start
  // (PasswordSection.tsx and CompletionMessage.component.tsx)
  window.LIFE_CYCLE_EVENT_BUS.on('security.submission-event', ({ output }) => {
    const eventName = output?.eventName || '';

    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  // postSettingsSubmissionEvent(settings) - password/device/phone/email/2FA/passwordless
  // settings submissions across SignInDetails. Caller passes the fully-formatted
  // settings string (e.g. `security:device signed out:${deviceType}`).
  window.LIFE_CYCLE_EVENT_BUS.on('security.settings-submission-event', ({ output }) => {
    const settings = output?.settings || '';

    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  // postSettingsSubmissionEventWebauthn() - no args, fixed payload
  // (WebAuthnEnrollment.component.tsx, CompletionMessage.component.tsx)
  window.LIFE_CYCLE_EVENT_BUS.on('security.webauthn-settings-event', () => {
    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        biometricEnablement: 'completed'
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  // postErrorEvent(pageSection, code, message) / handleApiError(error, pageSection)
  window.LIFE_CYCLE_EVENT_BUS.on('security.error-event', ({ output }) => {
    const pageSection = output?.pageSection || '';
    const code = output?.code || '';
    const message = output?.message || '';

    const DDOEvent = {
      category: {
        primaryCategory: ERROR
      },
      eventInfo: {
        eventName: 'post page error',
        error: [{
          type: 'error',
          displayType: 'inline',
          pageSection,
          message,
          code
        }]
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  // postOverlayEvent(eventName) - phone/email/passwordless OTP and unenroll modals
  window.LIFE_CYCLE_EVENT_BUS.on('security.overlay-event', ({ output }) => {
    const eventName = output?.eventName || '';

    const DDOEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });
};
